export default {
    student: [],
    active_student: [],
    student_chekout: [],
    total_income: 0,
    total_expense: 0
}